import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReportErrorStateComponent } from "./report-error-state.component";

/** Lets ReportErrorStateComponent be used from feature modules other than
 *  AppModule (e.g. DashboardNewModule) - a component can only be declared
 *  in one NgModule, so anything besides AppModule's own views imports this
 *  module instead of redeclaring the component. */
@NgModule({
  declarations: [ReportErrorStateComponent],
  imports: [CommonModule],
  exports: [ReportErrorStateComponent],
})
export class ReportErrorStateModule {}
